import { render, staticRenderFns } from "./TeamRequestsDetailManagerPage.vue?vue&type=template&id=b32ea428"
import script from "./TeamRequestsDetailManagerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamRequestsDetailManagerPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports